import { callWebUtils } from "../Components/CampaignMembers/helpers";
import logger from "./LoggerFrontend";
import { CustomerSucessController } from "@talentbait/shared-components";

export async function generateTextRecommendationStream(params, onTextUpdate) {
  logger.log("generateTextRecommendationStream", "called", params);

  const {
    channel,
    jobTitle,
    jobPostingUrl,
    orgaName,
    orgaId,
    userId,
    userName,
    language = "German",
    formality = "Sie"
  } = params;

  CustomerSucessController.send("Description Stream Started", {
    channel,
    user_id: userId,
    user_name: userName,
    organization_id: orgaId,
    organization_name: orgaName,
    job_title: jobTitle,
    job_url: jobPostingUrl
  });

  try {
    const context = {
      failed: (err) => {
        throw err;
      },
      completed: () => {
        // No state to update here
      }
    };

    let rawAutoGeneratedText = "";
    let autoGeneratedData = {};

    await callWebUtils(context, "generateTextRecommendationStream", [
      {
        body: {
          channel,
          jobTitle,
          jobPostingUrl,
          language,
          formality
        },
        onData: (textChunk) => {
          rawAutoGeneratedText += textChunk || "";

          if (onTextUpdate) {
            onTextUpdate(rawAutoGeneratedText);
          }

          if (!textChunk) return;

          if (channel !== "google-search") {
            autoGeneratedData = {
              autoGeneratedText: rawAutoGeneratedText,
              teaserText: rawAutoGeneratedText
            };
          } else {
            try {
              const jsonText = fixMalformedJson(rawAutoGeneratedText);
              const { ad = "", headlines = [] } = JSON.parse(jsonText);
              const [title, title2, title3] = headlines;

              autoGeneratedData = {
                autoGeneratedText: ad,
                teaserText: ad,
                title,
                autoTitle: title,
                title2,
                autoTitle2: title2,
                title3,
                autoTitle3: title3
              };
            } catch (err) {
              logger.log(
                "generateTextRecommendationStream",
                "could not parse google search stream"
              );
            }
          }
        }
      }
    ]);

    CustomerSucessController.send("Description Stream Ended", {
      status: "success",
      channel,
      user_id: userId,
      user_name: userName,
      organization_id: orgaId,
      organization_name: orgaName,
      job_title: jobTitle,
      job_url: jobPostingUrl
    });

    return autoGeneratedData;
  } catch (err) {
    const fallbackText = getDefaultTeaserText({
      channelShortName: channel,
      jobTitle
    });

    CustomerSucessController.send("Description Stream Ended", {
      status: "error",
      channel,
      user_id: userId,
      user_name: userName,
      organization_id: orgaId,
      organization_name: orgaName,
      job_title: jobTitle,
      job_url: jobPostingUrl
    });

    return {
      autoGeneratedText: fallbackText,
      teaserText: fallbackText
    };
  }
}

function fixMalformedJson(jsonText) {
  let quotationsCount = 0;
  let openBracketsCount = 0;
  let closeBracketsCount = 0;
  let openCurlyBracesCount = 0;
  let closeCurlyBracesCount = 0;

  for (let i = 0; i < jsonText.length; i++) {
    if (jsonText[i] === '"') quotationsCount++;
    if (jsonText[i] === "[") openBracketsCount++;
    if (jsonText[i] === "]") closeBracketsCount++;
    if (jsonText[i] === "{") openCurlyBracesCount++;
    if (jsonText[i] === "}") closeCurlyBracesCount++;
  }

  if (quotationsCount % 2 !== 0) jsonText += '"';
  jsonText += Array(Math.max(0, openBracketsCount - closeBracketsCount))
    .fill("]")
    .join("");
  jsonText += Array(Math.max(0, openCurlyBracesCount - closeCurlyBracesCount))
    .fill("}")
    .join("");

  return jsonText;
}

function getDefaultTeaserText({ channelShortName, jobTitle }) {
  return `Default teaser for ${channelShortName || "unknown"}: ${jobTitle || "No title provided"}`;
}
